export default {
      id: "icon-document-usage",
      viewBox: "0 0 125 104",
      url: __webpack_public_path__ + "icons.svg#icon-document",
      toString: function () {
        return this.url;
      }
    }